angular.module('app')
  .directive('keepScrollPos', function ($window, $timeout, $state, $transitions) {
    const scrollPosCache = {};

    return {
      link: (scope) => {
        $transitions.onStart({}, (transition) => {
          const from = transition.from();

          if (from.data && from.data.keepScrollPos) {
            const url = $state.href(from.name, transition.params('from'));

            const scrollPos = {
              x: $window.pageXOffset,
              y: $window.pageYOffset,
            };

            console.log(url, scrollPos);

            scrollPosCache[url] = scrollPos;
          }
        });

        $transitions.onFinish({}, (transition) => {
          const to = transition.to();

          let scrollPos = { x: 0, y: 0 };

          if (to.data && to.data.keepScrollPos) {
            const url = $state.href(to.name, transition.params('to'));

            scrollPos = scrollPosCache[url] || { x: 0, y: 0 };
          }

          $timeout(() => {
            console.log('Scroll to', scrollPos.x, scrollPos.y);
            $window.scrollTo(scrollPos.x, scrollPos.y);
          }, 0);
        });

        scope.$on('SCROLL', () => {
          const url = $state.href($state.current.name, $state.params);

          const scrollPos = scrollPosCache[url] || { x: 0, y: 0 };

          $timeout(() => {
            console.log('Scroll to', scrollPos.x, scrollPos.y);
            $window.scrollTo(scrollPos.x, scrollPos.y);
          }, 0);
        })
      },
    };
  });
